/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Grid } from '@mui/material';
import CelebrationCard from './Components/CelebrationCard';
import { setEventsData } from '../../../../../redux/NewsFeedRedux';
import { useDispatch, useSelector } from 'react-redux';
import { queryParams } from '../../../../../libs/HelperContent';
import ErrorMsgHook from '../../../../../libs/CustomHooks/ErrorMsgHook';
import { getEvents } from '../../../../actions/recognition_actions';
import NoData from '../../../../../components/Common/NoData';
import useInterSectionObserver from '../../../../../libs/CustomHooks/useIntersectionObserver';
import { feedActionContext } from '../../..';
import Loading from '../../../../../components/Common/Loaders/FullWidthLoader/Loading';

const CelebrationCardGrid = (props) =>
{
	const { search } = props;
	const itemsPerpage = 12;
	// Redux
	const session = useSelector((state: any) => state?.mysession?.session);
	const eventsData: any = useSelector((state: any) => state?.mynewsFeed?.eventData);
	const dispatch = useDispatch();
	const { setFeedCardActn } = useContext(feedActionContext);

	// State
	const [ loading, setLoading ] = useState<boolean>(false);
	const [ page, setPage ] = useState<number>(0);
	const [ count, setCount ] = useState<number>(0);

	// Ref-ImmidiateUpdate
	const countLoader = useRef<boolean>(true);
	const loaderRef = useRef<boolean>(false);
	const lastEleRef = useRef<HTMLDivElement | null>(null);

	// Custom-Hook
	const { handleErrMsg } = ErrorMsgHook();
	const LoadMoreList = useInterSectionObserver({ lastEleRef, loaderRef, count, data: eventsData, setPage });
	const queryParamRes = queryParams(session?.userId, session?.companyId, session?.empRole, session?.role, 'get');

	// EventCount
	const fetchEventsCount = (query: any) =>
	{
		if (!loading)
		{
			setLoading(true);
			query += '&count=true';
			getEvents(query)
				.then((res) =>
				{
					if (res.status)
					{
						setCount(res?.count);
						setLoading(false);
						countLoader.current = false;
					}
				})
				.catch((err) =>
				{
					setLoading(false);
					countLoader.current = false;
					console.log(err);
				});
		}
	};

	// Get-Event
	const getEventsData = () =>
	{
		const currentDate = new Date().setHours(0, 0, 0, 0);
		const query = `?limit=${itemsPerpage}&skip=${page}&timezone=${Intl.DateTimeFormat().resolvedOptions().timeZone.toString()}&currentDate=${currentDate}${queryParamRes}`;

		if (!loading)
		{
			setLoading(true);
			getEvents(query)
				.then((res) =>
				{
					if (res?.status)
					{
						if (page === 0)
						{
							// Initial page load
							setFeedCardActn([ 'allEventCmnt', res?.data[0] ]);

							// Determine if we need to fetch count
							if ((res?.data?.length >= itemsPerpage) || search !== '')
							{
								fetchEventsCount(query);
							}
							else
							{
								setCount(res?.data?.length);
								countLoader.current = false;
							}
							// Set initial events data
							dispatch(setEventsData(res?.data) ?? []);
						}
						else
						{
							// Append new events for subsequent pages
							dispatch(setEventsData([ ...eventsData, ...res?.data ?? [] ]));
						}

						setLoading(false);
					}
				})
				.catch((err) =>
				{
					setLoading(false);
					countLoader.current = false;
					handleErrMsg(err);
				});
		}
	};

	// Effect
	useEffect(() =>
	{
		getEventsData();
	}, []);

	useEffect(() =>
	{
		LoadMoreList();
	}, [ lastEleRef, count, eventsData ]);

	return (

		<Grid item xs={12} sx={{ backgroundColor: 'var(--whiteColor)' }} border='1px solid rgba(0, 0, 0, 0.12)' borderRadius={3.5} p='var(--pixel16)' height={'var(--percent100)'}>
			{loading && <Loading />}
			<Grid container spacing={1}>
				{eventsData?.length > 0
					? (eventsData?.map((data, index) => (
						<>

							<Grid
								item
								width={'100%'}
								key={data?.eventId}
							>
								<CelebrationCard
									data={data}
								/>
							</Grid>
							{(index === eventsData?.length - 1) && <span ref={lastEleRef}/>}

						</>
					)))
					: <div className='flexCol pdngXS justifyCntr'>
						<NoData noDataHead='No Events Available' color='lightTxt' src1='/images/Bpsnodata.svg' />
					</div>}
			</Grid>
		</Grid>
	);
};

export default CelebrationCardGrid;
